// extracted by mini-css-extract-plugin
export default {"form":"form_form__0yX7m","border":"form_border__Jc7OE","input":"form_input__zYX5S","label":"form_label__s6vJo","button":"form_button__M5vpq","error":"form_error__+AiAM"};